export const googleClientId = "590619125451-kmqkudu03gmfk4007kvj47c5cgah1b7s.apps.googleusercontent.com";
export const onesignalAppId = "6867d62e-b20c-417a-89cf-4f0af6051f5b";
export const facebookAppId = "213848975894435";
export const fields = "name,email,picture.type(large),first_name,last_name";
export const recaptchaSiteKey = "6LcPNWgUAAAAAOo2XDQzlwL-lUZbqrLQksnvh3XD";

const paypalCodes: {[language: string]: string} = {
    hu: "DT7NGDVDF32FY",
    lt: "RTU8ARKHRL7GY",
    et: "WNAWUV9R4FJAS",
    pl: "N4T93RBJXDTFN",
    en: "HY42QGRKBB944",
    "en-us": "8YRTLMQLE5Q42",
    "en-gb": "UBJVQVGZSC5WG",
};

export const getPaypalCode = (locale: string) => {
    if (paypalCodes[locale]) {
        return paypalCodes[locale];
    }
    return paypalCodes.en;
};

export const adsenseClientId = "ca-pub-4416317457738665";
export const eggHuntExerciseId = "5e909c3fc9501e001e941e26";
